"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeFromArray = void 0;
const removeFromArray = (array, index) => array.filter((_, filterIndex) => index !== filterIndex);
exports.removeFromArray = removeFromArray;
//# sourceMappingURL=array.js.map